/**
 * Expense Summary Cards Component
 */
import React from 'react';

const ExpenseSummaryCards = ({ summary }) => {
  if (!summary) return null;

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-4">
        <p className="text-slate-400 text-sm">Total Expenses</p>
        <p className="text-2xl font-bold text-white">£{summary.total_amount?.toLocaleString()}</p>
        <p className="text-xs text-slate-500">{summary.total_count} expenses</p>
      </div>
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-4">
        <p className="text-slate-400 text-sm">Tax Deductible</p>
        <p className="text-2xl font-bold text-amber-400">£{summary.total_tax_deductible?.toLocaleString()}</p>
      </div>
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-4">
        <p className="text-slate-400 text-sm">Reimbursed</p>
        <p className="text-2xl font-bold text-blue-400">£{summary.total_reimbursed?.toLocaleString()}</p>
      </div>
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-4">
        <p className="text-slate-400 text-sm">Pending</p>
        <p className="text-2xl font-bold text-amber-400">£{summary.total_pending?.toLocaleString()}</p>
      </div>
    </div>
  );
};

export default ExpenseSummaryCards;
